// extracted by mini-css-extract-plugin
module.exports = {"link":"style__link__JrmZP","disabled":"style__disabled__9m3Te","icon":"style__icon__lsBpl"};